(async () => {
  const storeModuleURL = window.__GLOBAL__.assets.store;
  const module = await import(storeModuleURL);
  const store = module.default;

  class proDealToggle extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      this.discountToggle = this.querySelector("[data-discount-toggle]");
      this.discountToggleText = this.querySelector(
        "[data-discount-toggle-text]"
      );

      this.discountToggleHandler = this.toggleDiscount.bind(this);

      this.discountToggle.addEventListener(
        "change",
        this.discountToggleHandler
      );
      store.events.subscribe('prodeal:discount-enable', this.updateToggleStatus.bind(this))
    }

    async toggleDiscount(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if(!this.getAttribute('verified')) {
        this.showVerificationModal();
        this.discountToggle.checked = false;
        return;
      }


      const enableDiscount = evt.target.checked;

      if (this.loadingDiscount) {
        evt.target.checked = !enableDiscount;
        return;
      }

      this.loadingDiscount = true;
      store.events.publish('cartLoading', true);

      if (enableDiscount) {
        this.discountToggleText.innerText = "ON";
        await fetch(`/discount/${window.customer.proDeal.code}`).then(() => {
          store.events.publish("prodeal:discount-enable", { enabled: true });
          this.loadingDiscount = false;
        });
      } else {
        this.discountToggleText.innerText = "OFF";
        await fetch(`/discount/empty`).then(() => {
          store.events.publish("prodeal:discount-enable", { enabled: false });
          this.loadingDiscount = false;
        });
      }

      const cartPayload = await fetch(`/cart/update.js`, {
        method: 'POST',
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {},
          sections: document.querySelector('main-cart').id,
          sections_url: window.routes.cart_url
        })
      })
      .then((response) => response.json())
      store.dispatch('cartUpdate', cartPayload, false);
      store.events.publish('cartLoading', false);
    }

    updateToggleStatus({enabled}) {
      if(enabled) {
        this.setToggleOn()
      } else {
        this.setToggleOff();
      }
    }

    setToggleOn() {
      this.discountToggleText.innerText = "ON";
      this.querySelector('input[type="checkbox"]').checked = true;
    }

    setToggleOff() {
      this.discountToggleText.innerText = "OFF";
      this.querySelector('input[type="checkbox"]').checked = false;
    }

    showVerificationModal() {
      const modal = this.querySelector('dialog');
      const closeButton = this.querySelector('[data-close-button]');
      const submitButton = this.querySelector('[data-pd-verification-submit]');
      modal.showModal();

      closeButton.addEventListener('click', () => {
        modal.close();
      })

      submitButton.addEventListener('click', (evt) => {
        evt.preventDefault();

        this.sendVerificationEmail();
      })
    }

    sendVerificationEmail() {
      fetch("https://a.klaviyo.com/client/events/?company_id=KkSJyW", {
        method: "POST",
        headers: {
          accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          revision: "2025-04-15",
        },
        body: JSON.stringify({
          data: {
            type: "event",
            attributes: {
              properties: {
                token: this.getAttribute("token"),
              },
              metric: {
                data: {
                  type: "metric",
                  attributes: {
                    name: "Email Verification",
                    service: "api",
                  },
                },
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: window.customer.email,
                  },
                },
              },
            },
          },
        }),
      })
      .then(() => {
        this.querySelector('.pro-deal__modal-success-message').removeAttribute('hidden');
      })
    }
  }
  if(!customElements.get("pro-deal-toggle")) {
    customElements.define("pro-deal-toggle", proDealToggle);
  }
})()